import { styled } from 'styled-system/jsx'

const WidgetHost = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: '4px',
    marginBottom: '4px',
    minHeight: '65px',
  },
})

export { WidgetHost }
